// deps
import React from "react";

// styles
import { BillDividerWrapper } from "./styles";

const BillDivider = () => {
    return <BillDividerWrapper />;
};

export default BillDivider;
